import { InsureIQStatusStyles } from '@harvestiq/constants';
import { LrpEndorsement } from '@harvestiq/iiq-common';
import { Chip, ChipProps } from '@mui/material';

export function EndorsementStatusChip({
  status,
  isExternallyManaged,
  externalStatus,
}: {
  status: LrpEndorsement['status'];
  isExternallyManaged: LrpEndorsement['isExternallyManaged'];
  externalStatus: LrpEndorsement['externalStatus'];
}) {
  // Show both internal and external status if externally managed
  if (isExternallyManaged && externalStatus) {
    const label = `${status} (AIP: ${externalStatus})`;
    return (
      <Chip
        label={label}
        color={InsureIQStatusStyles[status] as ChipProps['color']}
        size="small"
      />
    );
  }
  // Default to internal status
  else {
    return (
      <Chip
        label={status}
        color={InsureIQStatusStyles[status] as ChipProps['color']}
        size="small"
      />
    );
  }
}
